import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search--sprite",
  "use": "search--sprite-usage",
  "viewBox": "0 0 54 54",
  "content": "<symbol viewBox=\"0 0 54 54\" id=\"search--sprite\">\n<rect x=\"38.7\" y=\"30.6\" transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -17.6666 42.653)\" width=\"8\" height=\"24.1\" />\n<path d=\"M21.6,8C14.1,8,8,14.1,8,21.6c0,7.5,6.1,13.7,13.7,13.7c7.5,0,13.7-6.1,13.7-13.7C35.3,14.1,29.2,8,21.6,8z M21.6,43.3 C9.7,43.3,0,33.6,0,21.6C0,9.7,9.7,0,21.6,0c11.9,0,21.6,9.7,21.6,21.6C43.3,33.6,33.6,43.3,21.6,43.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol